import type { BillPdfPreviewRow } from "@/modules/data/services/use-bill-pdf-upload-session"

export type BillPdfFileState = "failed" | "parsed" | "parsing" | "pending"

const isBillPdfFileState = (state: string): state is BillPdfFileState =>
  state === "failed" ||
  state === "parsed" ||
  state === "parsing" ||
  state === "pending"

export const isFinishedBillPdfFileState = (state: string): boolean =>
  state === "failed" || state === "parsed"

export const isUnfinishedBillPdfFileState = (state: string): boolean =>
  state === "parsing" || state === "pending"

export const isUnsavedPreviewRow = (row: BillPdfPreviewRow): boolean =>
  row.status === "error" || row.status === "ready"

export const getBillPdfFileStateLabel = (
  state: string,
  translate: (key: string) => string
): string => {
  if (!isBillPdfFileState(state)) {
    return state
  }

  switch (state) {
    case "failed":
      return translate("upload.billPdf.fileStateFailed")
    case "parsed":
      return translate("upload.billPdf.fileStateParsed")
    case "parsing":
      return translate("upload.billPdf.fileStateParsing")
    case "pending":
      return translate("upload.billPdf.fileStatePending")
    default: {
      const exhaustiveState: never = state
      return exhaustiveState
    }
  }
}
